import {getTenant, getUserName} from "@iblai/ibl-web-react-common";

export const getCourseAPI = (limit = 12, offset = "", search = "", isProgram=false, useTenant=true) => {
  const tenant = getTenant()
  const queryParam = new URLSearchParams({
    ...(useTenant ? {
      tenant:tenant
    } : {} ),
    ...(isProgram ? {
      content:'programs'
    } : {}),
    ...(offset ? {
      offset:offset
    } : {}),
    limit,
    ...(search ? {
      query:encodeURIComponent(search)
    } : {})
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/personalized-catalog/${getUserName()}/?${queryParam}`;
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      return data || [];
    })
    .catch((error) => {
      console.error('Error fetching courses:', error);
      return [];
    });
};


